/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useCallback, useEffect, useMemo } from 'react'
import moment from 'moment'
import 'moment/locale/vi'
import { upperFirst } from 'lodash'
import { Checkbox, InputNumber } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Tooltip } from "antd"
import { deleteForceMail, deleteMail, restoreMailMany} from './helpers/call-api';
import { useDispatch } from 'react-redux';
import './style.scss'
import { getErrorMessage } from 'utils/index';
import { showConfirmModal } from 'actions/global';
import { useHistory } from 'react-router-dom';
import logo_default from 'assets/bw_image/default_img.png';
import useVerifyAccess from 'hooks/useVerifyAccess';

const MailTable = ({
    loading,
    data,
    totalPages,
    itemsPerPage,
    page,
    totalItems,
    onChangePage,
    handleUpdateStatusFlagged,
    checkValueFlagged,
    setDataList,
    typeMail,
    handleChangeRouterView,
    noPaging,
    mailParams,
    returnTo,
    hiddenMenu,
    onBulkFlagged,
    onBulkDelete,
}
) => {
    const dispatch = useDispatch();
    const history = useHistory()
    const { verifyPermission } = useVerifyAccess();
    const canCreateMail = verifyPermission('SYS_MAIL_CREATE');
    const [currentPage, setCurrentPage] = useState(Math.max(1, parseInt(page) || 1));
    const [selectedMailIds, setSelectedMailIds] = useState([]);
    const [bulkActionLoading, setBulkActionLoading] = useState(false);
    const canSelectMail = !hiddenMenu;

    useEffect(() => {
        setCurrentPage(Math.max(1, parseInt(page) || 1));
        setSelectedMailIds([]);
    }, [page]);

    useEffect(() => {
        setSelectedMailIds([]);
    }, [typeMail]);

    useEffect(() => {
        const availableIds = new Set(data.map((mail) => mail.mail_id));
        setSelectedMailIds((currentIds) => currentIds.filter((mailId) => availableIds.has(mailId)));
    }, [data]);

    const handleChangePage = useCallback(() => {
        const nextPage = Math.min(Math.max(1, parseInt(currentPage) || 1), Math.max(1, totalPages));
        if (nextPage !== parseInt(page)) onChangePage(nextPage);
    }, [currentPage, page, totalPages]);

    const totalShowRecord = useMemo(() => {
        if (data.length < itemsPerPage) {
            return data.length;
        } else if (itemsPerPage > totalItems) {
            return totalItems;
        } else {
            return itemsPerPage;
        }
    }, [data, itemsPerPage, totalItems]);

    const selectedMails = useMemo(() => {
        const selectedIdSet = new Set(selectedMailIds);
        return data.filter((mail) => selectedIdSet.has(mail.mail_id));
    }, [data, selectedMailIds]);

    const isAllSelected = data.length > 0 && selectedMailIds.length === data.length;
    const isPartiallySelected = selectedMailIds.length > 0 && !isAllSelected;

    const toggleMailSelection = (mailId) => {
        setSelectedMailIds((currentIds) => currentIds.includes(mailId)
            ? currentIds.filter((id) => id !== mailId)
            : [...currentIds, mailId]);
    };

    const toggleSelectAll = () => {
        setSelectedMailIds(isAllSelected ? [] : data.map((mail) => mail.mail_id));
    };

    const handleBulkFlagged = async () => {
        setBulkActionLoading(true);
        try {
            const result = await onBulkFlagged(selectedMails);
            setSelectedMailIds(result?.failedIds || []);
        } catch (error) {
            getErrorMessage(error);
        } finally {
            setBulkActionLoading(false);
        }
    };

    const handleBulkDelete = () => {
        const selectedCount = selectedMails.length;
        const isForceDelete = typeMail === 'trash';
        dispatch(
            showConfirmModal(
                [isForceDelete
                    ? `Bạn có thực sự muốn xóa vĩnh viễn ${selectedCount} mail đã chọn?`
                    : `Bạn có thực sự muốn chuyển ${selectedCount} mail đã chọn vào thùng rác?`],
                async () => {
                    setBulkActionLoading(true);
                    try {
                        const result = await onBulkDelete(selectedMails);
                        setSelectedMailIds(result?.failedIds || []);
                    } catch (error) {
                        getErrorMessage(error);
                    } finally {
                        setBulkActionLoading(false);
                    }
                }
            )
        );
    };

    const handleDelete = (value, index) => {
        const isForceDelete = typeMail === 'trash';
        dispatch(
            showConfirmModal(
                [isForceDelete ? 'Bạn có thực sự muốn xóa mail vĩnh viễn?' : 'Bạn có thực sự muốn chuyển mail vào thùng rác?'],
                () => {
                    const request = isForceDelete ? deleteForceMail(value?.mail_id) : deleteMail(value?.mail_id);
                    request.then(() => {
                        const cloneData = JSON.parse(JSON.stringify(data))
                        cloneData.splice(index, 1)
                        setDataList((prev) => ({
                            ...prev,
                            items: cloneData,
                            totalItems: Math.max(0, prev.totalItems - 1)
                        }))
                        const nextPage = cloneData.length === 0 && currentPage > 1 ? currentPage - 1 : currentPage;
                        onChangePage(nextPage);
                    }).catch(getErrorMessage)
                }
            )
        )
    };



    if (loading) {
        return (
            <div className='loading_email_custom'>
                <LoadingOutlined />
            </div>
        )
    }

    const replyMail = (id) => {
        let {mail_id} = id;
        localStorage.setItem("isReply", true)
        history.push(`/mail/detail/${mail_id}`, { typeMail, mailParams, returnTo })
      }
      const replyAllMail = (id) => {
        let {mail_id} = id;
        localStorage.setItem("isReplyAll", true)
        history.push(`/mail/detail/${mail_id}`, { typeMail, mailParams, returnTo })
      }
      const forwardMail = (id) => {
        let {mail_id} = id;
        history.push(`/mail/compose?forward_id=${mail_id}`, { typeMail, mailParams, returnTo })
      }
    
    const handleRecoverMail = (id) => {
        let {mail_id} = id;
        restoreMailMany({
            ids: mail_id,
        })
            .then(() => onChangePage(currentPage))
            .catch(getErrorMessage);
    }    

    return (
        <React.Fragment>
            {canSelectMail && data && data.length > 0 && (
                <div className="bw_mail_bulk_toolbar" role="toolbar" aria-label="Thao tác nhiều email">
                    <Checkbox
                        aria-label={isAllSelected ? 'Bỏ chọn tất cả email trên trang' : 'Chọn tất cả email trên trang'}
                        checked={isAllSelected}
                        indeterminate={isPartiallySelected}
                        disabled={bulkActionLoading}
                        onChange={toggleSelectAll}
                    >
                        {selectedMailIds.length > 0
                            ? `Đã chọn ${selectedMailIds.length} email`
                            : 'Chọn tất cả trên trang'}
                    </Checkbox>
                    <div className="bw_mail_bulk_actions">
                        <button
                            type="button"
                            className="bw_mail_bulk_button bw_mail_bulk_star"
                            disabled={!selectedMailIds.length || bulkActionLoading}
                            onClick={handleBulkFlagged}
                        >
                            <i className="fi fi-rr-star" aria-hidden="true" />
                            Đánh dấu sao
                        </button>
                        <button
                            type="button"
                            className="bw_mail_bulk_button bw_mail_bulk_delete"
                            disabled={!selectedMailIds.length || bulkActionLoading}
                            onClick={handleBulkDelete}
                        >
                            <i className="fi fi-rr-trash" aria-hidden="true" />
                            {typeMail === 'trash' ? 'Xóa vĩnh viễn' : 'Xóa'}
                        </button>
                    </div>
                </div>
            )}
            {data && data.length && data.length > 0 ? data.map((x, i) => {
                const sendMoment = moment(x?.senddate, ['MM/DD/YYYY HH:mm', 'DD/MM/YYYY HH:mm:ss', moment.ISO_8601], true)
                const current_time = sendMoment.isValid() ? upperFirst(sendMoment.fromNow()) : x?.senddate
                return (
                    <div className={`bw_list_email ${x?.is_read ? '' : "bw_non_read"} ${canSelectMail ? 'bw_mail_selectable' : ''} ${selectedMailIds.includes(x?.mail_id) ? 'bw_mail_selected' : ''}`} key={x?.mail_id || i}

                    >
                        {canSelectMail && (
                            <Checkbox
                                className="bw_mail_select_checkbox"
                                aria-label={`Chọn email ${x?.mail_subject || ''}`}
                                checked={selectedMailIds.includes(x?.mail_id)}
                                disabled={bulkActionLoading}
                                onClick={(event) => event.stopPropagation()}
                                onChange={() => toggleMailSelection(x?.mail_id)}
                            />
                        )}
                        <Tooltip title={`${x?.is_flagged ? 'Có đánh dấu sao' : 'Không đánh dấu sao'}`} placement="bottom">
                            <span className={`bw_start_email ${x?.is_flagged ? "bw_active" : null}`}
                                role="button"
                                tabIndex={0}
                                aria-label={x?.is_flagged ? 'Bỏ đánh dấu sao' : 'Đánh dấu sao'}
                                onClick={() => checkValueFlagged(handleUpdateStatusFlagged, x, i)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        checkValueFlagged(handleUpdateStatusFlagged, x, i);
                                    }
                                }}
                            />
                        </Tooltip>
                        <div className="bw_us_email"
                            onClick={() => handleChangeRouterView(x)}
                        >
                            <img
                                src={x?.default_picture || logo_default}
                                onError={(event) => {
                                    event.currentTarget.onerror = null;
                                    event.currentTarget.src = logo_default;
                                }}
                            />
                            <h3>{x?.full_name}</h3>
                        </div>
                        <p
                            onClick={() => handleChangeRouterView(x)}
                        >
                            {x?.mail_subject}
                        </p>
                        <span className="bw_time_email">{current_time}</span>
                        <div className="bw_active_items">
                            {typeMail === 'trash' ? (
                                <Tooltip title={`Phục hồi mail`} placement='bottom'>
                                    <a onClick={() => handleRecoverMail(x)}><i className="fi-rr-arrow-alt-circle-up"></i></a>
                                </Tooltip>
                            ) : canCreateMail ? (
                                <Tooltip title={`Trả lời tất cả`} placement="bottom">
                                    <a
                                        onClick={()=> replyAllMail(x)}
                                    ><i className="fi fi-rr-reply-all" /></a>
                                </Tooltip>
                            ) : null}

                            {typeMail === 'trash' || !canCreateMail ? null : (
                                <Tooltip title={`Trả lời`} placement="bottom">
                                    <a  
                                        onClick={()=> replyMail(x)}
                                    ><i className="fi fi-rr-edit" /></a>
                                </Tooltip>
                            )}

                            {typeMail === 'trash' || !canCreateMail ? null : (
                                <Tooltip title={`Chuyển tiếp`} placement="bottom">
                                    <a
                                        onClick={() => forwardMail(x)}
                                    ><i className="fi fi-rr-share" /></a>
                                </Tooltip>
                            )}

                            <Tooltip title={`${typeMail !== 'trash' ? 'Chuyển vào thùng rác' : 'Xóa vĩnh viễn'}`} placement="bottom">
                                <a
                                    onClick={() => handleDelete(x, i)}
                                >
                                    <i className="fi fi-rr-trash" />
                                </a>
                            </Tooltip>
                        </div>
                    </div>
                )
            }) : (
                <div className="no_email_custom" >
                    Không có thư
                </div>
            )}

            {!noPaging ? <div className='bw_row bw_mt_2 bw_show_table_page'>
                <div className='bw_col_6'>
                    <p>
                        Hiển thị {totalShowRecord}/{totalItems} thư
                    </p>
                </div>
                <div className='bw_col_6 bw_flex bw_justify_content_right bw_align_items_center'>
                    <div className='bw_nav_table'>
                        <button
                            type='button'
                            aria-label='Trang trước'
                            disabled={currentPage <= 1}
                            onClick={() => {
                                onChangePage(parseInt(currentPage) - 1);
                            }}
                            className={currentPage > 1 ? 'bw_active' : ''}>
                            <span className='fi fi-rr-angle-small-left'></span>
                        </button>
                        <InputNumber
                            min={1}
                            style={{
                                marginRight: '6px',
                            }}
                            onChange={(e) => {
                                setCurrentPage(e);
                            }}
                            onPressEnter={handleChangePage}
                            onBlur={() => handleChangePage()}
                            value={currentPage}
                            max={totalPages}
                        />
                        <span className='bw_all_page'>/ {totalPages}</span>
                        <button
                            type='button'
                            aria-label='Trang sau'
                            disabled={parseInt(currentPage) >= parseInt(totalPages)}
                            onClick={() => {
                                onChangePage(parseInt(currentPage) + 1);
                            }}
                            className={parseInt(currentPage) < parseInt(totalPages) ? 'bw_active' : ''}>
                            <span className='fi fi-rr-angle-small-right'></span>
                        </button>
                    </div>
                </div>
            </div> : null}

        </React.Fragment >
    )
}

export default MailTable
